/* eslint-disable @typescript-eslint/naming-convention */
import { StatusEnum } from '../../enums/status.enum';

export const StoriesConstants: any = {
    timeLimit: '3000',
    storyMessage: 'Story ',
    confirmMessage: 'Are you sure you want to delete the following Stories?',
    confirmation : 'Delete Selected Stories?',
    deleteStoryHeading: 'Story Deleted',
    storyNotFoundHeading: 'Story Not Found',
    deleteMessage: ' has been successfully deleted',
    storyNotExistMessage: 'Your request could not be completed',
    successSeverity: 'success',
    errorSeverity: 'error',
    notfound: 'Not Found',
    storyItemStart: '<br/><br/>',
    storyItemEnd: '',
    acceptLabel: 'Delete',
    rejectLabel: 'Cancel',
    name : 'name',
    author : 'author',
    modifiedDate : 'modifiedDate',
    publishedDate : 'publishedDate',
    story : 'story',
    status : 'status',
    id : 'id',
    subject : 'subject',
    confirmationMessage : 'Are you sure that you want to proceed?',
    Copy : 'Copy',
    Successfully : 'Successfully',
    storyCopied : 'Story Copied',
    copied : 'copied',
    leftPanelView : 'leftPanel',
    ellipses: ' ...',
    maxNumberOfChars: 18,
    milliseconds: 1000,
    storyLabel: 'Story Name',
    statusLabel: 'Status',
    ascending : 'ASCENDING',
    descending : 'DESCENDING',
    errorHeading: 'Error',
    serverErrorMessage: 'An error has occurred. Please contact customer support.',
    newsroomRootPath: '/Newsroom',
    statusLabels: {
        [StatusEnum.DRAFT]: 'DRAFT',
        [StatusEnum.INREVIEW]: 'IN REVIEW',
        [StatusEnum.SCHEDULED]: 'SCHEDULED',
        [StatusEnum.PUBLISHED]: 'PUBLISHED',
        [StatusEnum.RETRACTED]: 'RETRACTED',
        [StatusEnum.FAILED]: 'FAILED',
        [StatusEnum.MODERATED]: 'MODERATED',
        [StatusEnum.FAILED_REVIEW]: 'FAILED REVIEW',
    },
    sidebarSectionNewsroom: 'Newsroom',
    sidebarSectionNewswire: 'Newswire',
    sideBarItemLabel: 'Newsroom Stories',
    sidebarAmplifyLabel: 'New Story',
    sideBarNoItemsText: 'No Newsroom Stories',
};
